import { useState } from "react";
import { Box, Slider, Paper, Grid, Divider } from "@mui/material";
import { Typography } from '@mui/material';
import { BLUE } from "assets/constants/Colors";
import { LIGHT_GREY } from "assets/constants/Colors";
import { WHITE } from "assets/constants/Colors";

const ROICalculatorPage = () => {

    const [duration, setDuration] = useState(5);
    const [devcost, setDevCost] = useState(16400);
    const [liccost, setLicCost] = useState(2000);
    const [instances, setInstances] = useState(200);
    const [employees, setEmployees] = useState(1.5);
    const [salary, setSalary] = useState(60000);
    const year1Savings = (salary * employees) - (devcost);
    const roi = (year1Savings / devcost) * 100;
    const breakEvenYears = devcost / (salary * employees);
    const roiYear2 = (year1Savings / (devcost + liccost)) * 100;

    return (
        <>
            <div className='top-gen-ai-usecases-wrapper' style={{ width: '100%', display: 'flex', overflow: 'auto' }}>
                <Box
                    sx={{
                        minHeight: "10vh",
                        bgcolor: LIGHT_GREY,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        p: 3,
                    }}
                >
                    <Paper
                        elevation={4}
                        sx={{
                            maxWidth: 500,
                            width: "100%",
                            p: 4,
                            borderRadius: 3,
                            bgcolor: WHITE,
                        }}
                    >
                        <Typography variant="h5" fontWeight={600} gutterBottom>
                            Today's Process Cost
                        </Typography>

                        <Divider sx={{ mb: 3 }} />

                        {/* Process Duration Slider */}
                        <Box sx={{ mb: 4 }}>
                            <Typography gutterBottom>
                                Process Duration: {duration.toLocaleString()} mins
                            </Typography>
                            <Slider
                                value={duration}
                                min={5}
                                max={8 * 60}
                                step={5}
                                onChange={(e, val) => setDuration(val)}
                                valueLabelDisplay="auto"
                            />
                        </Box>

                        {/* Process Instances Slider */}
                        <Box sx={{ mb: 4 }}>
                            <Typography gutterBottom>
                                Instances : {instances} per week
                            </Typography>
                            <Slider
                                value={instances}
                                min={1}
                                max={500}
                                step={1}
                                onChange={(e, val) => setInstances(val)}
                                valueLabelDisplay="auto"
                            />
                        </Box>

                        {/* Full time Employees Slider */}
                        <Box sx={{ mb: 4 }}>
                            <Typography gutterBottom>Full Time Employees on process: {employees} </Typography>
                            <Slider
                                value={employees}
                                min={1}
                                max={30}
                                step={0.5}
                                onChange={(e, val) => setEmployees(val)}
                                valueLabelDisplay="auto"
                            />
                        </Box>

                        {/* Average Salary Slider */}
                        <Box sx={{ mb: 4 }}>
                            <Typography gutterBottom>Average Salary per employee : {salary} USD </Typography>
                            <Slider
                                value={salary}
                                min={10000}
                                max={200000}
                                step={100}
                                onChange={(e, val) => setSalary(val)}
                                valueLabelDisplay="auto"
                            />
                        </Box>

                    </Paper>
                </Box>
                <Box
                    sx={{
                        minHeight: "10vh",
                        bgcolor: LIGHT_GREY,
                        display: "flex",
                        verticalAlign: 'top',
                        p: 3,
                    }}
                >
                    <Paper
                        elevation={4}
                        sx={{
                            maxWidth: 500,
                            width: "100%",
                            p: 4,
                            borderRadius: 3,
                            bgcolor: WHITE,
                        }}
                    >
                        <Typography variant="h5" fontWeight={600} gutterBottom>
                            Enterprise Agentic-AI Cost
                        </Typography>

                        <Divider sx={{ mb: 3 }} />

                        {/* Dev Cost Slider */}
                        <Box sx={{ mb: 4 }}>
                            <Typography gutterBottom>
                                Dev & Year-1 Lic Cost: {devcost.toLocaleString()} USD
                            </Typography>
                            <Slider
                                value={devcost}
                                min={0}
                                max={100000}
                                step={100}
                                onChange={(e, val) => setDevCost(val)}
                                valueLabelDisplay="auto"
                            />
                        </Box>

                        {/* Annual Lic Cost Slider */}
                        <Box sx={{ mb: 4 }}>
                            <Typography gutterBottom>
                                Annual Lic & Maintenance Cost : {liccost} USD/yr
                            </Typography>
                            <Slider
                                value={liccost}
                                min={1}
                                max={10000}
                                step={100}
                                onChange={(e, val) => setLicCost(val)}
                                valueLabelDisplay="auto"
                            />
                        </Box>

                    </Paper>
                </Box>

                <Box
                    sx={{
                        minHeight: "10vh",
                        width: '30%',
                        bgcolor: LIGHT_GREY,
                        display: "flex",
                        verticalAlign: 'top',
                        p: 3,
                    }}
                >
                    <Paper
                        elevation={4}
                        sx={{
                            maxWidth: 500,
                            width: "100%",
                            p: 4,
                            borderRadius: 3,
                            bgcolor: WHITE,
                        }}
                    >
                        <Typography variant="h5" fontWeight={600} gutterBottom>
                            Return On Investment
                        </Typography>

                        <Divider sx={{ mb: 4 }} />
                        {/* Results */}
                        <Paper
                            variant="outlined"
                            sx={{
                                p: 2,
                                borderRadius: 2,
                                backgroundColor: WHITE
                            }}
                        >
                            <Grid container spacing={1}>
                                <Grid item xs={12}>
                                    <Typography gutterBottom>
                                        Year-1 Savings
                                    </Typography>
                                    <Typography gutterBottom style={{ color: '#1565c0' }}>
                                        USD {year1Savings.toLocaleString('en-US')}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography gutterBottom>
                                        Year-1 ROI (%)
                                    </Typography>
                                    <Typography gutterBottom style={{ color: BLUE }}>
                                        {roi.toFixed(1).toLocaleString()}%
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography gutterBottom>
                                        Breakeven Years
                                    </Typography>
                                    <Typography gutterBottom style={{ color: BLUE }}>
                                        {breakEvenYears.toFixed(2)}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography gutterBottom>
                                        Year-2+ ROI (%)
                                    </Typography>
                                    <Typography gutterBottom style={{ color: BLUE }}>
                                        {roiYear2.toFixed(1).toLocaleString()}%
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Paper>
                </Box>
            </div>
        </>
    );

}
export default ROICalculatorPage;
